import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PythonTema5 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema5_Organizacion_Codigo.pdf`;
  /*const pdfUrl = "/pdf/Tema5_Organizacion_Codigo.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema 5: Organización de Código</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Tema 5: Organización de Código" />
      </Container>
    </>
  );
};

 export default PythonTema5;
